var parent = require('../../es/array/from');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/react-app-polyfill/~/core-js/features/array/from.js
// module id = 722
// module chunks = 5